const actions = {
  methods: {
    delete_ ({ id, name }) {
      this.$store.dispatch('setOverlay', true)
      this.$root.$dialog.confirm({
        text: `${this.lang.permissions.dialog.deleteConfirm} ${name}?`,
        title: this.lang.confirm.title,
        waitForResult: true
      }).then(res => {
        this.$store.dispatch('setOverlay', false)
        if (res) this.$store.dispatch('saveMixed', { page: 9, type: 1, data: { page: 'permissions', id }, ignoreResponseBar: false })
      })
    }
  }
}
export default actions
